module.exports = "/_next/static/images/google@2x-7528d4e09ea43531ed899ddbd4b76547.png";